import { defineFieldAdapter, type FieldTransformers } from '@libs/shared/frontend/helpers/define-field-adapter.helper';

import { OrganizationUserApiKeyStatusEnum, type components } from '@/libs/openapi';
import { formatDate } from '@/utils/format.util';

const API_KEY_STATUS_LABELS: Record<OrganizationUserApiKeyStatusEnum, string> = {
  [OrganizationUserApiKeyStatusEnum.Value1]: 'Active',
  [OrganizationUserApiKeyStatusEnum.Value0]: 'Inactive',
};

export const fromApiOrganizationUserApiKeyFieldAdapter = defineFieldAdapter({
  fields: {
    status: (value: OrganizationUserApiKeyStatusEnum) => API_KEY_STATUS_LABELS[value],
    createdAt: formatDate('withTime'),
    expiresAt: formatDate('withTime'),
    lastUsedAt: (value) => value && formatDate('withTime')(value),
  } satisfies FieldTransformers<components['schemas']['OrganizationUserApiKeyResponseDto']>,
  meta: {},
}, 'strict');

export const toApiOrganizationUserApiKeyFieldAdapter = defineFieldAdapter({
  fields: {} satisfies FieldTransformers<components['schemas']['OrganizationUserApiKeyResponseDto']>,
}, 'loose');
